import {
	displayedPhotosAtom,
	photosAtom,
	selectedPhotosAtom,
	selectedPhotosIDsAtom,
	updatePhotos,
} from "./photos-state"
import { sortOptionAtom } from "./photos-view-state"
import { store } from "../store"
import { PhotoRecord } from "@/lib/catalog"
import { saveCurrentAppState } from "../store-history"
import { projectAtom, updateCurrentProject } from "../project/projects-state"
import { stateAtom } from "../undoable-state"
import { focusAtom } from "jotai-optics"

export type CustomOrderLocation = "before" | "after"

export const photosCustomOrderAtom = focusAtom(stateAtom, (optic) => optic.prop("customOrder"))

export const restoreCustomPhotoOrdering = () => {
	const photos = store.get(photosAtom)

	const newCustomOrder = {}

	for (const photo of Object.values(photos)) {
		newCustomOrder[photo.id] = photo.customSortingIndex
	}

	store.set(photosCustomOrderAtom, {
		...newCustomOrder,
	})
}

export const updateCustomPhotoOrdering = (
	anchorPhoto: PhotoRecord,
	location: CustomOrderLocation,
) => {
	const selectedPhotos = store.get(selectedPhotosAtom)
	const selectedPhotoIds = store.get(selectedPhotosIDsAtom)
	const displayedPhotos = store.get(displayedPhotosAtom)
	const sortOption = store.get(sortOptionAtom)
	const currentProject = store.get(projectAtom)

	if (sortOption !== "customReordered") {
		store.set(sortOptionAtom, "customReordered")

		if (currentProject) {
			updateCurrentProject({ sortOption: "customReordered" })
		}
	}

	// Removing selected files from the array itself
	const filteredDisplayedPhotos = displayedPhotos.filter(
		(photo) => !selectedPhotoIds.has(photo.id) || photo === anchorPhoto,
	)

	// We initially start with the currently selected order
	const index = filteredDisplayedPhotos.findIndex((photo) => photo.id === anchorPhoto.id)

	if (index === -1) {
		// Shouldn't ever happen
		return
	}

	let orderedPhotos: PhotoRecord[] = []

	if (location === "before") {
		orderedPhotos = [
			...filteredDisplayedPhotos.slice(0, index),
			...selectedPhotos,
			...filteredDisplayedPhotos.slice(index),
		]
	} else {
		orderedPhotos = [
			...filteredDisplayedPhotos.slice(0, index + 1),
			...selectedPhotos,
			...filteredDisplayedPhotos.slice(index + 1),
		]
	}

	const newCustomOrder = {}

	updatePhotos((photos) => {
		for (let i = 0; i < orderedPhotos.length; i++) {
			const photo = orderedPhotos[i]

			if (!photo) continue

			photos[photo.id] = { customSortingIndex: i }
			newCustomOrder[photo.id] = i + 1
		}
	})

	store.set(photosCustomOrderAtom, {
		...newCustomOrder,
	})

	saveCurrentAppState("Reordered photos")
}
